import { render, staticRenderFns } from "./ClientSuiteFrame.vue?vue&type=template&id=f61a47de"
import script from "./ClientSuiteFrame.vue?vue&type=script&lang=js"
export * from "./ClientSuiteFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports